import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const BeraChainLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <path className={t5} d="M11.336 10.878c-.019-.06-.034-.12-.044-.181a4.093 4.093 0 0 0-.064-.267h.002c.277-.403 1.603-2.51.094-3.865-1.674-1.502-3.63.467-3.63.467l.007.009a4.834 4.834 0 0 0-2.759-.01c-.012-.011-1.961-1.964-3.63-.466-1.669 1.498.134 3.921.143 3.935-.02.056-.034.114-.045.173C1.23 11.71 0 12.03 0 13.838c0 1.807 1.286 3.291 3.911 3.291h1.077c.006.008.449.612 1.36.612.845 0 1.403-.607 1.408-.612h1.028c2.625 0 3.91-1.451 3.91-3.291 0-1.683-1.066-2.076-1.356-2.96h-.002Zm12.547-2.063s.194-1.74-1.289-2.115v-.696h-1.15v.68c-1.565.333-1.363 2.133-1.363 2.133v.296s-.202 1.8 1.363 2.133v1.497c-1.65.287-1.441 2.146-1.441 2.146v.298s-.202 1.8 1.363 2.134v.681h1.15v-.7c1.484-.374 1.288-2.115 1.288-2.115.066 0 .119-.05.119-.112v-.073a.116.116 0 0 0-.119-.113s.195-1.725-1.27-2.11v-1.534h-.015c1.565-.333 1.362-2.133 1.362-2.133.066 0 .119-.05.119-.113v-.073a.116.116 0 0 0-.119-.112l.002.001Zm-.936 6.074h-.106a.116.116 0 0 0-.118.113v.073c0 .062.053.112.118.112h.104c0 1.082-.37 1.262-.496 1.294-.02.004-.042-.01-.042-.03v-.345c0-.191-.126-.295-.251-.351a.616.616 0 0 0-.504 0c-.126.056-.252.16-.252.35v.344a.033.033 0 0 1-.04.03c-.124-.03-.498-.209-.498-1.292v-.298c0-1.081.372-1.262.498-1.293.02-.004.04.01.04.03v.345c0 .191.126.295.252.351.16.072.343.072.504 0 .125-.056.251-.16.251-.351v-.344c0-.02.02-.035.04-.03.125.03.5.21.5 1.292Zm-.03-5.774h.107c0 1.081-.374 1.262-.5 1.291a.033.033 0 0 1-.04-.03v-.344c0-.19-.124-.295-.251-.351a.618.618 0 0 0-.504 0c-.125.056-.252.161-.252.35v.346c0 .02-.02.034-.04.03-.124-.03-.498-.212-.498-1.292v-.3c0-1.081.375-1.262.5-1.291a.033.033 0 0 1 .04.03v.344c0 .19.125.294.251.351.16.072.344.072.504 0 .126-.057.252-.161.252-.35v-.346c0-.02.02-.035.04-.03.124.03.498.212.498 1.292h-.105a.116.116 0 0 0-.119.113v.074c0 .06.053.113.119.113h-.002Zm-4.785 2.776s.201-1.81-1.378-2.136V8.128c1.538-.348 1.338-2.127 1.338-2.127h-.86c0 1.081-.373 1.262-.497 1.291a.033.033 0 0 1-.04-.03V6.92c0-.191-.126-.296-.252-.351a.616.616 0 0 0-.504 0c-.126.056-.252.16-.252.351v.344a.03.03 0 0 1-.04.03c-.126-.03-.497-.212-.497-1.292h-.86s-.207 1.847 1.427 2.145v1.606c-1.591.32-1.388 2.136-1.388 2.136v.3s-.203 1.817 1.388 2.137v1.53c-1.634.298-1.427 2.146-1.427 2.146h.86c0-1.082.373-1.263.497-1.292a.033.033 0 0 1 .04.03v.343c0 .191.126.296.252.351.16.072.344.072.504 0 .126-.056.252-.16.252-.351v-.344c0-.02.02-.035.041-.03.125.03.497.213.497 1.293h.859s.2-1.78-1.338-2.128v-1.551c1.58-.326 1.378-2.135 1.378-2.135.064 0 .117-.05.117-.112V12a.116.116 0 0 0-.119-.113l.002.003Zm-.965.298h.104c0 1.081-.373 1.262-.498 1.292a.033.033 0 0 1-.04-.03v-.344c0-.19-.126-.296-.252-.352a.618.618 0 0 0-.503 0c-.126.057-.252.163-.252.352v.344a.03.03 0 0 1-.04.03c-.126-.03-.498-.212-.498-1.292v-.298c0-1.082.373-1.264.498-1.293a.033.033 0 0 1 .04.03v.344c0 .19.126.295.252.352.16.071.343.071.503 0 .126-.057.252-.162.252-.352v-.343c0-.021.021-.036.042-.03.124.03.498.212.498 1.292h-.106a.116.116 0 0 0-.118.113v.072c0 .062.053.113.118.113Z" />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== fillAttribute || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} fill={fillAttribute} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[12] = className;
    $[13] = fillAttribute;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};